module.exports = __webpack_public_path__ + "img/12.6453f57a.jpg";